import { getTemaRegion } from "../../config/temaRegion";
import namesByRegion from "./toolDisplayNamesByRegion.json";

function getRegionalBundle() {
  const region = getTemaRegion();
  return namesByRegion[region] ?? namesByRegion.us;
}

const regionalBundle = getRegionalBundle();
const regionalTools = regionalBundle.tools ?? {};

/** Active tool display names for the configured TEMA region. */
export const TOOL_DISPLAY_NAMES = { ...regionalTools };

/** Library persistence uses `lesson-flow` for Quick Sheets outputs. */
export const LIBRARY_TOOL_ID_TO_DISPLAY_NAME = {
  "lesson-flow": TOOL_DISPLAY_NAMES["quick-sheets"],
  "concept-questions": TOOL_DISPLAY_NAMES["concept-questions"],
  "question-variations": TOOL_DISPLAY_NAMES["question-variations"],
  "quick-assessment": TOOL_DISPLAY_NAMES["quick-assessment"],
  "teach-this-topic": TOOL_DISPLAY_NAMES["teach-this-topic"],
  "explain-differently": TOOL_DISPLAY_NAMES["explain-differently"],
  "content-simplifier": TOOL_DISPLAY_NAMES["content-simplifier"],
  "question-paper": TOOL_DISPLAY_NAMES["question-paper"],
  "section-builder": TOOL_DISPLAY_NAMES["section-builder"],
  "difficulty-balancer": TOOL_DISPLAY_NAMES["difficulty-balancer"],
  "doubt-solver": TOOL_DISPLAY_NAMES["doubt-solver"],
  "slide-deck-generator": TOOL_DISPLAY_NAMES["slide-deck-generator"],
  "project-builder": TOOL_DISPLAY_NAMES["project-builder"],
  "activity-generator": TOOL_DISPLAY_NAMES["activity-generator"],
  "real-world-task": TOOL_DISPLAY_NAMES["real-world-task"],
};

export function getToolDisplayName(toolId) {
  return (
    TOOL_DISPLAY_NAMES[toolId] ??
    LIBRARY_TOOL_ID_TO_DISPLAY_NAME[toolId] ??
    toolId
  );
}

export function getContentSimplifierDocumentTitle() {
  return regionalBundle.contentSimplifierDocumentTitle ?? "CONTENT SIMPLIFIER";
}

export function getQuickAssessmentDefaultTitle(topic) {
  const prefix =
    regionalBundle.quickAssessmentDefaultTitlePrefix ?? "Quick Assessment";
  const label = String(topic ?? "").trim();
  return label ? `${prefix}: ${label}` : prefix;
}

export function getDifficultyBalancerDefaultTitle(topic) {
  const prefix =
    regionalBundle.difficultyBalancerDefaultTitlePrefix ?? "Difficulty Balancer";
  const label = String(topic ?? "").trim();
  return label ? `${prefix}: ${label}` : prefix;
}

export function temaExportAuthor(toolId) {
  return `Tema ${getToolDisplayName(toolId)}`;
}

export function toolWorkspaceAriaLabel(toolId) {
  return `${getToolDisplayName(toolId)} workspace`;
}
